import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';

export default function hasSuggestionPills(scenarioId: SearchScenarioId): boolean {
    const store = getScenarioStore(scenarioId);
    return store.suggestionPills.size > 0 || store.suggestionSegments.size > 0;
}
